export const environment = {
  production: true,
   SERVER_URL: 'https://ewakili.judiciary.go.tz:8087',
  // SERVER_URL: 'http://10.80.80.254:8080',
  //SERVER_URL: 'http://ewakilitraining.judiciary.go.tz',
  CLIENT_ID: 'tams',
  CLIENT_SECRET: 'tams.123',
  DEFAULT_COUNTRY: 219,
};
